import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { X, CheckCircle2 } from 'lucide-react';
import { Button } from './ui/Button';
import { INFO_EMAIL, sendInfoMail } from '../utils/infoMail';
type InquiryType = 'Arrangera event' | 'Abonnera lokalen';
interface EventInquiryModalProps {
  onClose: () => void;
}
const inputClass = 'w-full h-11 px-3 rounded-lg border border-[#7C8062]/20 bg-white focus:border-[#7C8062] focus:ring-2 focus:ring-[#7C8062]/20 outline-none transition-[border-color,box-shadow] text-sm';
const labelClass = 'block text-xs font-medium text-[#1A1A1A]/70 mb-1.5';
export function EventInquiryModal({
  onClose
}: EventInquiryModalProps) {
  const [type, setType] = useState<InquiryType>('Arrangera event');
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');
  const [guests, setGuests] = useState('');
  const [details, setDetails] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [status, setStatus] = useState<'form' | 'sent' | 'mailto'>('form');
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);
  const today = new Date().toISOString().slice(0, 10);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    const subject = `[EVENTFÖRFRÅGAN] ${type} – ${name} – ${date} kl ${time}`;
    const message = [`════════════════════════════════`, `   NY EVENTFÖRFRÅGAN`, `════════════════════════════════`, '', `▸ TYP:        ${type}`, `▸ DATUM:      ${date}`, `▸ TID:        ${time}`, `▸ ANTAL:      ${guests} personer`, '', `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━`, `   VAD VILL DE ARRANGERA?`, `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━`, `  ${details}`, '', `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━`, `   KONTAKTUPPGIFTER`, `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━`, `  Namn:     ${name}`, `  E-post:   ${email}`, `  Telefon:  ${phone}`, '', `════════════════════════════════`, `Svara direkt på detta mejl för att nå kunden.`, `════════════════════════════════`].join('\n');
    setIsSubmitting(true);
    const ok = await sendInfoMail({
      subject,
      message,
      fromName: `Top Notch Event – ${name}`,
      replyTo: email,
      name
    });
    setIsSubmitting(false);
    if (ok) {
      setStatus('sent');
    } else {
      setError(`Något gick fel. Försök igen eller mejla oss på ${INFO_EMAIL}.`);
    }
  };
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 0.2,
    ease: [0.23, 1, 0.32, 1]
  }} className="fixed inset-0 z-50 flex items-start sm:items-center justify-center p-4 bg-black/50 backdrop-blur-sm overflow-y-auto" onClick={onClose} data-id="element-406" data-mp="2cnemxc373dnp">
      <motion.div role="dialog" aria-modal="true" aria-labelledby="event-inquiry-title" initial={{
      opacity: 0,
      scale: 0.96,
      y: 8
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} onClick={e => e.stopPropagation()} className="bg-[#F2EDE4] rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden my-8" data-id="element-407" data-mp="23afv5qkaftzx">
        <div className="bg-white px-6 py-4 border-b border-[#7C8062]/15 flex items-center justify-between" data-id="element-408" data-mp="2m6fp36wtt7m5">
          <h2 id="event-inquiry-title" className="text-xl font-serif text-[#1A1A1A]" data-id="element-409" data-mp="27dlx4m0daz0l">
            Eget event hos oss
          </h2>
          <button onClick={onClose} className="p-2 -mr-2 text-[#1A1A1A]/50 hover:text-[#1A1A1A] hover:bg-[#F2EDE4] rounded-full transition-colors" aria-label="Stäng" data-id="element-410" data-mp="vvazvn8u96dv">
            <X className="w-5 h-5" data-id="element-411" data-mp="1h3mux4spya2q" />
          </button>
        </div>

        <div className="p-6 md:p-8" data-id="element-412" data-mp="1cak7zfig5yvi">
          {status === 'form' ? <form onSubmit={handleSubmit} className="space-y-5" data-id="element-413" data-mp="17c8wl0ci7gb6">
              <fieldset data-id="element-414" data-mp="17aeedtsma2as">
                <legend className={labelClass} data-id="element-415" data-mp="12dnxj48zn2ob">Vad gäller det? *</legend>
                <div className="grid grid-cols-2 gap-1 p-1 bg-white rounded-lg border border-[#7C8062]/20" data-id="element-416" data-mp="12bb8y88q5u2a">
                  {(['Arrangera event', 'Abonnera lokalen'] as InquiryType[]).map(opt => <button key={opt} type="button" onClick={() => setType(opt)} aria-pressed={type === opt} className={`py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${type === opt ? 'bg-[#7C8062] text-[#F2EDE4]' : 'text-[#1A1A1A]/60 hover:text-[#1A1A1A]'}`} data-id="element-417" data-mp="1q2qesazpmtia">
                        {opt}
                      </button>)}
                </div>
              </fieldset>

              <div className="grid grid-cols-2 sm:grid-cols-3 gap-4" data-id="element-418" data-mp="2q8u3kmq6f1dy">
                <div className="col-span-2 sm:col-span-1" data-id="element-419" data-mp="2v8oyd1d2ob4a">
                  <label htmlFor="ev-date" className={labelClass} data-id="element-420" data-mp="301i2po4mphfu">
                    Dag *
                  </label>
                  <input id="ev-date" type="date" required min={today} value={date} onChange={e => setDate(e.target.value)} className={inputClass} data-id="element-421" data-mp="34z1gkmxezs79" />
                </div>
                <div data-id="element-422" data-mp="3iz2nok49vvv6">
                  <label htmlFor="ev-time" className={labelClass} data-id="element-423" data-mp="1jmq7l3g3lw2u">
                    Tid *
                  </label>
                  <input id="ev-time" type="time" required value={time} onChange={e => setTime(e.target.value)} className={inputClass} data-id="element-424" data-mp="1olb7f1rfudqr" />
                </div>
                <div data-id="element-425" data-mp="1qjufngmc6sf4">
                  <label htmlFor="ev-guests" className={labelClass} data-id="element-426" data-mp="1qkcjaybbw8x2">
                    Antal personer *
                  </label>
                  <input id="ev-guests" type="number" min={1} required inputMode="numeric" value={guests} onChange={e => setGuests(e.target.value)} className={inputClass} placeholder="t.ex. 20" data-id="element-427" data-mp="1lix2jig6ookh" />
                </div>
              </div>

              <div data-id="element-428" data-mp="2j7qk57i5domg">
                <label htmlFor="ev-details" className={labelClass} data-id="element-429" data-mp="2j7709l8xsq5s">
                  {type === 'Arrangera event' ? 'Vad vill ni arrangera? *' : 'Vad ska lokalen användas till? *'}
                </label>
                <textarea id="ev-details" required value={details} onChange={e => setDetails(e.target.value)} className="w-full min-h-[96px] p-3 rounded-lg border border-[#7C8062]/20 bg-white focus:border-[#7C8062] focus:ring-2 focus:ring-[#7C8062]/20 outline-none transition-[border-color,box-shadow] text-sm resize-y" placeholder={type === 'Arrangera event' ? 'T.ex. bakkurs för kollegor, chokladprovning, födelsedagsfika…' : 'T.ex. frukostmöte, AW, privat fest…'} data-id="element-430" data-mp="2xskvzn9qtvl2" />
              </div>

              <div className="pt-1 space-y-4" data-id="element-431" data-mp="2a30ez9x5h8ef">
                <div data-id="element-432" data-mp="1v7kdiju8qa80">
                  <label htmlFor="ev-name" className={labelClass} data-id="element-433" data-mp="1v958gakgvv6e">
                    Namn *
                  </label>
                  <input id="ev-name" type="text" required autoComplete="name" value={name} onChange={e => setName(e.target.value)} className={inputClass} placeholder="För- och efternamn" data-id="element-434" data-mp="2065j6ys9hm3u" />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-435" data-mp="21oxc1oqk8ftn">
                  <div data-id="element-436" data-mp="1wr45uvp9bltd">
                    <label htmlFor="ev-email" className={labelClass} data-id="element-437" data-mp="1wrdmhsoewgme">
                      E-post *
                    </label>
                    <input id="ev-email" type="email" required autoComplete="email" value={email} onChange={e => setEmail(e.target.value)} className={inputClass} placeholder="din@epost.se" data-id="element-438" data-mp="1nxs7q9c8yzcz" />
                  </div>
                  <div data-id="element-439" data-mp="ywtfvsiueu90">
                    <label htmlFor="ev-phone" className={labelClass} data-id="element-440" data-mp="yxcqeo65ygd0">
                      Telefon *
                    </label>
                    <input id="ev-phone" type="tel" required autoComplete="tel" value={phone} onChange={e => setPhone(e.target.value)} className={inputClass} placeholder="070-123 45 67" data-id="element-441" data-mp="13ttb18e5mclc" />
                  </div>
                </div>
              </div>

              {error && <p role="alert" className="p-3 bg-red-50 text-red-700 text-sm rounded-lg border border-red-100" data-id="element-442" data-mp="q37zk4r154xh">
                  {error}
                </p>}

              <div className="pt-2" data-id="element-443" data-mp="3tkpzzr4h39nv">
                <Button type="submit" isLoading={isSubmitting} className="w-full py-3.5 text-base" data-id="element-444" data-mp="2ef3m8aeqx2v">
                  Skicka förfrågan
                </Button>
                <p className="text-center text-xs text-[#1A1A1A]/50 mt-3" data-id="element-445" data-mp="3f8slegm95osg">
                  Vi återkommer så snart vi kan.
                </p>
              </div>
            </form> : <div className="text-center py-6 space-y-4" data-id="element-446" data-mp="3o9ihzmjc7j78">
              <div className="w-14 h-14 bg-[#7C8062]/10 rounded-full flex items-center justify-center mx-auto" data-id="element-447" data-mp="2rk9iyhpvw68a">
                <CheckCircle2 className="w-7 h-7 text-[#7C8062]" data-id="element-448" data-mp="2wiui0dtegjv5" />
              </div>
              <h3 className="text-2xl font-serif text-[#1A1A1A]" data-id="element-449" data-mp="30kzah9843ag7">
                {status === 'sent' ? 'Tack för din förfrågan!' : 'Nästan klart'}
              </h3>
              <p className="text-[#1A1A1A]/70 max-w-sm mx-auto text-sm leading-relaxed" data-id="element-450" data-mp="28u1i669nprv9">
                {status === 'sent' ? `Vi har tagit emot din förfrågan för den ${date} kl ${time} och återkommer till dig via e-post eller telefon.` : `Ditt mejlprogram har öppnats med förfrågan ifylld. Tryck på skicka där så når den oss på ${INFO_EMAIL}.`}
              </p>
              <div className="pt-4" data-id="element-451" data-mp="1waxhw9hdl3l5">
                <Button onClick={onClose} className="w-full sm:w-auto px-8" data-id="element-452" data-mp="1w9urs3rvn56a">
                  Stäng
                </Button>
              </div>
            </div>}
        </div>
      </motion.div>
    </motion.div>;
}